// extracted by mini-css-extract-plugin
export default {"dropBox":"NewDocumentUploader_dropBox__LJPLe","agrement":"NewDocumentUploader_agrement__axZUX"};